import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaPrint, FaDownload, FaTrash } from "react-icons/fa";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const GetMemeberRecord = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const society = localStorage.getItem("society");

  const [data, setData] = useState(location.state?.record || []);
  const unitTitle =
    location.state?.unitTitle ||
    "UNIT NO A 503, Mr. Ashok, Shravan Dayal & Mrs. Beena Ashok Dayal";
  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text("Unit Wise General Ledger", 75, 15);
    doc.setFontSize(11);
    doc.text("For The Year 2021-2022", 80, 22);
    doc.text("01/04/2021 to 31/03/2022", 73, 29);
    doc.text(`Unit: ${unitTitle}`, 14, 38);

    autoTable(doc, {
      startY: 45,
      head: [
        ["Date", "Type", "Reference No", "Cheque No", "Cheque Date", "Dr Amount", "Cr Amount", "Balance"]
      ],
      body: data.map((row) => [
        row.date || "-",
        row.type || "-",
        row.referenceNo || "-",
        row.chequeNo || "-",
        row.chequeDate || "-",
        row.drAmount || "0.00",
        row.crAmount || "0.00",
        row.balance || "0.00"
      ]),
    });

    doc.save("unit_ledger.pdf");
  };

  // 🗑️ Delete all records
  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete all records?")) {
      setData([]);
    }
  };

  return (
    <div className="container my-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <button className="btn btn-outline-dark" onClick={() => navigate(-1)}>
          <FaArrowLeft />
        </button>
        <div className="text-center flex-grow-1">
          <h5 className="fw-bold">Unit Wise General Ledger</h5>
          <p className="mb-0">For The Year 2021-2022</p>
          <p className="mb-0">01/04/2021 to 31/03/2022</p>
        </div>
        <div className="d-flex gap-2">
          <button className="btn btn-outline-dark" onClick={() => window.print()}>
            <FaPrint />
          </button>
          <button className="btn btn-outline-dark" onClick={handleDownloadPDF}>
            <FaDownload />
          </button>
          <button className="btn btn-outline-dark" onClick={handleDelete}>
            <FaTrash />
          </button>
        </div>
      </div>

      <div className="mb-3 fw-semibold">{unitTitle}</div>
      <div className="table-responsive">
        <table className="table table-bordered table-striped table-hover">
          <thead className="table-light text-center">
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>Reference No</th>
              <th>Cheque No</th>
              <th>Cheque Date</th>
              <th>Dr Amount</th>
              <th>Cr Amount</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {data.length > 0 ? (
              data.map((row, index) => (
                <tr key={index}>
                  <td>{row.date || "-"}</td>
                  <td>{row.type || "-"}</td>
                  <td>{row.referenceNo || "-"}</td>
                  <td>{row.chequeNo || "-"}</td>
                  <td>{row.chequeDate || "-"}</td>
                  <td>{row.drAmount || "0.00"}</td>
                  <td>{row.crAmount || "0.00"}</td>
                  <td>{row.balance || "0.00"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">No records found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GetMemeberRecord;
